import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Textbox, DropdownList ,BusyIndicator} from 'adp-react-components';
import { Cookies } from 'react-cookie';
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
function findQuestionIndex(array, selectedquestion) {
  var questions = array;
  for (var i = 0; i < questions.length; i++) {
    if (questions[i].question == selectedquestion) {
      return parseInt(questions[i].id);
    }

  }
  return -1;
}
export default class SecurityQnA extends React.Component {

  constructor(props) {
    console.log("constructor initialized for CreateSecurityQnA");
    super(props);
    this.state = {
      question1: '',
      question2: '',
      question3: '',
      answer1: '',
      answer2: '',
      answer3: '',
      question1index: -1,
      question2index: -1,
      question3index: -1,
      disabled: false,
      selectedQuestions: ['', '', ''],
      questionlist: [],
      questionlist1: [],
      questionlist2: [],
      questionlist3: [],
      originalList: [],
      showBusyIndicator:true

    }
    this.onQuestion1Change = this.onQuestion1Change.bind(this);
    this.onQuestion2Change = this.onQuestion2Change.bind(this);
    this.onQuestion3Change = this.onQuestion3Change.bind(this);

  }

  onQuestion3Change(val) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      question3: val
    });
    this.state.selectedQuestions[2] = val;
    let result = [];
    let selectedArray = [];
    selectedArray = this.state.selectedQuestions;
    result = this.state.questionlist;
    var newData = result.slice();
    var index = findQuestionIndex(this.state.originalList, val);
    for (var i = 0; i <= newData.length; i++) {
      for (var j = 0; j < selectedArray.length; j++) {
        if (newData[i] == selectedArray[j]) {
          var removed_elements = newData.splice(i, 1);
          i = -1;
        }
      }
    }
    this.setState({
      questionlist2: newData,
      questionlist1: newData,
      question3index: index
    })
    this.props.getQuestion3(index);
  }
  onQuestion2Change(value) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      question2: value,
    });
    this.state.selectedQuestions[1] = value;
    let result = [];
    let selectedArray = [];
    selectedArray = this.state.selectedQuestions;
    result = this.state.questionlist;
    var newData = result.slice();
    var index = findQuestionIndex(this.state.originalList, value);
    for (var i = 0; i <= newData.length; i++) {
      for (var j = 0; j < selectedArray.length; j++) {
        if (newData[i] == selectedArray[j]) {
          var removed_elements = newData.splice(i, 1);
          i = -1;
        }
      }
    }

    this.setState({
      question2index: index,
      questionlist1: newData,
      questionlist3: newData,

    })
    this.props.getQuestion2(index);
  }
  onQuestion1Change(val) {
    this.props.showErrorMessage('', 'error');
    this.state.selectedQuestions[0] = val;
    this.setState({
      question1: val,
    });
    let result = [];
    let selectedArray = [];
    selectedArray = this.state.selectedQuestions;
    result = this.state.questionlist;
    var newData = result.slice();
    var index = findQuestionIndex(this.state.originalList, val);
    for (var i = 0; i <= newData.length; i++) {
      for (var j = 0; j < selectedArray.length; j++) {
        if (newData[i] == selectedArray[j]) {
          var removed_elements = newData.splice(i, 1);
          i = -1;

        }
      }
    }

    this.setState({
      question1index: index,
      questionlist2: newData,
      questionlist3: newData

    })
    this.props.getQuestion1(index);
  }
  onChangeAnswer3(value) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      answer3: value,
    });
    this.props.getAnswer3(value);
  }

  onChangeAnswer2(value) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      answer2: value,
    });
    this.props.getAnswer2(value);
  }

  onChangeAnswer1(value) {
    this.props.showErrorMessage('', 'error');
    this.setState({
      answer1: value,
    });
    this.props.getAnswer1(value);
  }
  handleKeyPress(e) {
    if(!this.props.isButtonEnabled()){
    if (e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.props.onSubmit();
    }
  }
  }
  componentDidMount() {
    console.log("qna ajax call triggerred getDefaultQuestionsForm");
    fetch(context + '/enroll/adpPassword.faces?getDefaultQuestionsForm', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'getDefaultQuestionsForm=getDefaultQuestionsForm&getDefaultQuestionsForm:submitButton=&javax.faces.ViewState=' + Tier0.get("javax.faces.ViewState").value
    }).then(response => {
      console.log("qna ajax call  getDefaultQuestionsForm returned");
      return response.json();
    }).then(data => {
      if (data.success == "false" || data.success == false) {
        this.props.showErrorMessage(data.wizard.message, 'error');
        return;
      }
      if (data.success == "true" || data.success == true) {
        if (data.misc.showTerms == "true" || data.misc.showTerms == true) {
          this.props.fetchTermsnConditions(data.misc.terms);
          this.props.updateModelFlag(true);
          this.props.showTermCondition();
        }
        console.log("qna ajax call  doing json data");
        var MyJson = data.qna.questionsList;
        MyJson = entities.decode(data.qna.questionsList);
        //  MyJson=  MyJson.replace(/&#034;/gi, '"');
        //MyJson = MyJson.replace(/&#039;/gi, "'");
        var jsonData = JSON.parse(MyJson);
        var arrayvar = this.state.questionlist.slice()

        jsonData.forEach(element => {
          arrayvar.push(element.question);
        });

        this.setState({
          questionlist: arrayvar,
          questionlist1: arrayvar,
          questionlist2: arrayvar,
          questionlist3: arrayvar,
          originalList: jsonData,
          showBusyIndicator:false

        })
        console.log(this.state);

      }
    });



  }
  componentWillMount(){
    this.props.showErrorMessage('', 'error');
  }
  render() {
    const cookies = new Cookies();

    let langLocaleCookie = cookies.get('ADPLangLocaleCookie');
    console.log("langLocaleCookie:" + langLocaleCookie);
    return (
      <div className="form-group">
       {this.state.showBusyIndicator?(
        <BusyIndicator
            size={ 'xl' }
            overlay={true}
            fullScreen={true}
            style={{color:'#1a8099'}}

        />
       ):null }
        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="question1">{this.props.question1Lable}</label>
          </div>
        </div>

        <div className="showcase">
          <DropdownList className="vdl-dropdown-list__input-container_qna"
            placeholder={this.props.select}
            value={this.state.question1}
            onChange={this.onQuestion1Change}
            data={this.state.questionlist1}
            caseSensitive={false}
          >
          </DropdownList>
        </div>
        <br />
        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="answer1">{this.props.answerLable}</label>
          </div>
        </div>
        <div className="input-group-full">
          <Textbox
            value={this.state.answer1}
            type="text"
            onChange={this.onChangeAnswer1.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}
          >
          </Textbox>
        </div>
        <br />
        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="question2">{this.props.question2Lable}</label>
          </div>

        </div>

        <div className="showcase">
          <DropdownList className="vdl-dropdown-list__input-container_qna"
            placeholder={this.props.select}
            value={this.state.question2}
            onChange={this.onQuestion2Change}
            data={this.state.questionlist2}
            caseSensitive={false}>
          </DropdownList>
        </div>
        <br />
        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="answer2">{this.props.answerLable}</label>
          </div>
        </div>
        <div className="input-group-full">
          <Textbox
            value={this.state.answer2}
            type="text"
            onChange={this.onChangeAnswer2.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}
          >
          </Textbox>
        </div>
        <br />
        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="question3">{this.props.question3Lable}</label>
          </div>

        </div>

        <div className="showcase">
          <DropdownList className="vdl-dropdown-list__input-container_qna"
            placeholder={this.props.select}
            value={this.state.question3}
            onChange={this.onQuestion3Change}
            data={this.state.questionlist3}
            caseSensitive={false}
          >
          </DropdownList>
        </div>
        <br />

        { /* input-group-full */}

        <div className="vdl-row">
          <div className="vdl-col-sm-14 vdl-col-xs-12">
            <label htmlFor="answer3">{this.props.answerLable}</label>
          </div>
        </div>
        <div className="input-group-full">
          <Textbox
            value={this.state.answer3}
            type="text"
            onChange={this.onChangeAnswer3.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}
          >
          </Textbox>
        </div>
      </div>


    )
  }

}



// WEBPACK FOOTER //
// ./src/components/utils/security-qna.js